import { render, staticRenderFns } from "./ServiceLogViewSlider.vue?vue&type=template&id=671b1cf1&"
import script from "./ServiceLogViewSlider.vue?vue&type=script&lang=ts&"
export * from "./ServiceLogViewSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceLogViewSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports